import { useCallback, useEffect, useRef, useState } from "react";

import { getEmployee } from "@/api/employees";
import type { EmployeeDetailVO } from "@/api/employees/type";

/**
 * 拉取员工详情
 * @param employeeId 员工 ID
 * @param open 弹窗是否打开
 */
export const useEmployeeDetail = (employeeId?: string | null, open = false) => {
  const [employee, setEmployee] = useState<EmployeeDetailVO | null>(null);
  const [loading, setLoading] = useState(false);
  const requestIdRef = useRef(0);

  /** 按 ID 请求详情 */
  const loadDetail = useCallback(async (id: string) => {
    const requestId = ++requestIdRef.current;
    setLoading(true);
    try {
      const res = await getEmployee(id);
      if (requestId !== requestIdRef.current) return;
      setEmployee(res.data);
    } catch {
      if (requestId !== requestIdRef.current) return;
      setEmployee(null);
    } finally {
      if (requestId === requestIdRef.current) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    if (!open || !employeeId) return;
    void loadDetail(employeeId);
  }, [employeeId, loadDetail, open]);

  /** 关闭弹窗时清空，避免下次打开闪旧数据 */
  useEffect(() => {
    if (open) return;
    requestIdRef.current += 1;
    setEmployee(null);
    setLoading(false);
  }, [open]);

  return {
    employee,
    loading,
  };
};
